import { IconButton, Tooltip } from "@mui/material";
import { copyTextToClipboard } from "../helpers/copyToClipBoardHelper";
import { AttachmentActionProps } from "./AttachmentActionProps";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/pro-regular-svg-icons";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";

export const CopyAction = ({ attachmentId, onDownload }: AttachmentActionProps) => {
    async function onCopyLinkIconClicked(attachmentId: number) {
        const result = await onDownload(attachmentId, true);
        if (result) {
            copyTextToClipboard(result.url);
        }
    }
    return (
        <Tooltip title={"Copy link to clipboard"}>
            <IconButton onClick={() => onCopyLinkIconClicked(attachmentId)}>
                <FontAwesomeIcon icon={faLink} style={MirageTheme.icons.sizeS} />
            </IconButton>
        </Tooltip>
    );
};
